import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "line-item line-item-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_card = _resolveComponent("el-card");
  const _component_audit_state = _resolveComponent("audit-state");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_aside = _resolveComponent("el-aside");
  return _openBlock(), _createBlock(_component_el_aside, {
    width: "300px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeTab = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "需求流程",
        name: "proc",
        class: "history-wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "100%"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_timeline, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processLogs, (proc, index) => {
              return _openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                type: proc.type,
                timestamp: proc.optTime
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(proc.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proc.items, (item, ind) => {
                  return _openBlock(), _createElementBlock("div", {
                    key: ind
                  }, [item && item.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    class: "line-item"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_col, {
                      span: 7
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item[0]) + " :", 1)]),
                      _: 2
                    }, 1024), _createVNode(_component_el_col, {
                      span: 17
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item[1]), 1)]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024)) : _createCommentVNode("", true)]);
                }), 128))]),
                _: 2
              }, 1032, ["type", "timestamp"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "历史修改记录",
        class: "history-wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "100%"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_timeline, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsEditLogs, (log, index) => {
              return _openBlock(), _createBlock(_component_el_timeline_item, {
                key: index,
                timestamp: log.createTime,
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_card, null, {
                  default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(log.content), 1)]),
                  _: 2
                }, 1024), _createVNode(_component_el_collapse, {
                  accordion: ""
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
                    name: "1"
                  }, {
                    title: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 审核详情 ", -1)]))]),
                    default: _withCtx(() => [_createVNode(_component_el_tabs, null, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.approveInfos, (appr, index) => {
                        return _openBlock(), _createBlock(_component_el_tab_pane, {
                          key: index,
                          class: "audit-pane"
                        }, {
                          label: _withCtx(() => [_createTextVNode(_toDisplayString(appr.roleName) + " ", 1), _createVNode(_component_audit_state, {
                            state: appr.approveState
                          }, null, 8, ["state"])]),
                          default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(appr.aprroveContent), 1)]),
                          _: 2
                        }, 1024);
                      }), 128))]),
                      _: 2
                    }, 1024)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["timestamp"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}